// aiModelCatalog — the ONE model-mode catalog + live-diagnostics demotion,
// shared by the header model dropdown (AiModelSwitcherBody) and the
// workspace-pin picker (AiSettingsPanel PinSection) so the two can never
// drift. Extracted 2026-08-31 (AI-SETTINGS-WORKSPACE-PROVIDER-PIN-NO-UI-
// WRITER-1): the pin surface needed the same rows, and a second copy is the
// exact drift the models-list removal deleted.
//
// Both consumers assign these exports ONTO their component `scope` as VALUES
// (`MODEL_ROWS: AI_MODEL_ROWS`, `catalogRows: aiModelCatalogRows`) and call
// them via `this.…` — never as bare identifiers from inside scope methods —
// because a frank `to-json` lift drops top-of-file import bindings
// (`unresolvable-identifier`, see AiSettingsPanel's chooseAuth note). Both
// functions are self-contained for the same reason: no free variables.

export const AI_MODEL_ROWS = [
  { key: 'auto', label: 'ai.model.auto', sub: 'ai.model.auto.sub' },
  // Product names stay Latin (docs/I18N-GLOSSARY.md rule 4) — only the
  // description line is a bundle key.
  { key: 'simone', label: 'Simone', sub: 'ai.model.simone.sub' },
  { key: 'anthropic', label: 'Anthropic', sub: 'ai.model.anthropic.sub' },
  { key: 'openai', label: 'OpenAI', sub: 'ai.model.openai.sub' },
  { key: 'gemini', label: 'Gemini', sub: 'ai.model.gemini.sub' },
  { key: 'openrouter', label: 'OpenRouter', sub: 'ai.model.openrouter.sub' },
  { key: 'research', label: 'ai.model.research', sub: 'ai.model.research.sub' },
  { key: 'cheap', label: 'ai.model.cheap', sub: 'ai.model.cheap.sub' }
]

// Apply the live per-provider diagnostics (GET /core/ai/providers — fetched
// by the consumers when their menu OPENS, never here) to a catalog: an
// unusable provider's row comes back DISABLED with the live reason swapped
// into `sub` (fixed one-line row height — a demoted row never grows and
// shifts its neighbours). Absent diagnostics leave every row enabled, so a
// menu degrades to plain labels, never to a broken/empty one. 'auto' is the
// router's own fallback mode, not a single provider — never demoted.
// Returns NEW row objects without an `active` field: which row is "current"
// is each consumer's own question (root.modelMode vs. the workspace pin).
export const aiModelCatalogRows = (rows, diagnostics) => {
  const byProvider = new Map(
    (diagnostics && diagnostics.providers ? diagnostics.providers : []).map((p) => [p.provider, p])
  )
  return rows.map((m) => {
    const diag = m.key === 'auto' ? null : byProvider.get(m.key)
    const disabled = Boolean(diag && diag.usable === false)
    return {
      ...m,
      disabled,
      sub: disabled && diag.reason ? diag.reason : m.sub
    }
  })
}
